export default function (el) {
	$('#myIframe').iFrameResize( [{log:true}] );
}
